import { render, staticRenderFns } from "./FoodType.vue?vue&type=template&id=0e3aab0f&scoped=true"
import script from "./FoodType.vue?vue&type=script&lang=js"
export * from "./FoodType.vue?vue&type=script&lang=js"
import style0 from "./FoodType.vue?vue&type=style&index=0&id=0e3aab0f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3aab0f",
  null
  
)

export default component.exports